import { useContext, useEffect, useState } from "react";
import { useNavigate, Link } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";

import AAOEModal  from "react-modal";

import { getAAOE, getTestInfo, getSystemMsg } from '../../utils/api';
import { cartActions } from '../../store/cart';
import MenuContext from '../../store/MenuContext';
import TestClasses from './Test.module.css';

import AAOE from '../../pages/AAOEfrm';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Test = (props) => {
    const navigate = useNavigate();
    const cartState = useSelector(state => state.cart);
    const dispatch = useDispatch();

	const [aaoeData, setAaoeData] = useState([]);

	const propstestid = props.test.TestId;
		useEffect(() => {
			async function fetchAAOEData() {
			if(props.test.AAOE === 1) {
				const aaoeData = await getAAOE(propstestid);
				setAaoeData(aaoeData);    
			}			
        }
        fetchAAOEData();
		}, [propstestid]);

	const [showAAOEModal, setShowAAOEModal] = useState(false);
	function closeAAOEModal () {
		setShowAAOEModal(false);
	}

	const menuTheme = useContext(MenuContext);
    const notifyCart = () => toast("Added To Cart");

    const testInCart = cartState.items.some((test) => {
        return test.ID === props.test.ID;
    });
	
	const slugify = s =>
	  s
		.toLowerCase()
		.trim()
		.replace(/[\s_]+/g, "-")           // spaces -> hyphens
		.replace(/[^a-z0-9-]/g, "");       // remove punctuation

	const testurl = `../details/${props.test.TestId}/${props.page}/${slugify(props.test.TestName)}`;
	
    const viewTestHandlerFull = () => {
		if (menuTheme === "HAMBURGER") {
			navigate(`../details/${props.test.TestId}/${props.page}/${props.test.TestName}`);
		}
    };
	const viewTestHandler = () => {
		navigate(`../details/${props.test.TestId}/${props.page}/${props.test.TestName}`);
    };

	const addToCartHandler = (e) => {
		e.stopPropagation();

		if (props.test.AAOE === 1) {
			setShowAAOEModal(true);
			return; // Exit now — wait for modal confirmation
		}

		handleAddToCart();
	};
	const [msg,setMsg] = useState('');
	  useEffect(() => {
		async function fetchMessage() {
		  try {
			const data = await getSystemMsg("Restricted States");
			setMsg(data);
		  } catch (err) {
			console.error("Failed to fetch message:", err);
			setMsg("Thank you for trusting us!"); // fallback message
		  }
		}
		fetchMessage();
	  }, []);

	// This function is called when modal completes (e.g. on Confirm button)
	const handleAddToCart = () => {
		const aaoedata = Object.assign({ aaoeanswers: { "none": "none" } }, props.test);
		console.log("add to cart handler");
		console.log(props.requiredTests);
		if (props.requiredTests === "CANNOT ORDER") {
				navigate("../noServiceSysMsg", { replace: true});
		}else if (props.requiredTests === "WARNING") {
			alert(JSON.stringify(msg, null, 2));
		}else{
			if (props.requiredTests.length !== 0) {
				for (let i = 0; i < props.requiredTests.length; i++) {
					const testInfoR = Object.assign({ required: 1 }, props.requiredTests[i]);
					const testInfoRA = Object.assign({ aaoeanswers: { "none": "none" } }, testInfoR);
					dispatch(cartActions.add(testInfoRA));
				}
			}
		}

		dispatch(cartActions.add(aaoedata));
		notifyCart();

		if (sessionStorage.getItem("Q3") === 'Yes') {
			if (props.conTests.length !== 0) {
				for (let i = 0; i < props.conTests.length; i++) {
					const testInfoR = Object.assign({ required: 0 }, props.conTests[i]);
					const testInfoRA = Object.assign({ aaoeanswers: { "none": "none" } }, testInfoR);
					dispatch(cartActions.add(testInfoRA));
				}
			}
		}
	};

 
	const handleAAOEData = (data) => {
		let data2= data['AaoeID'];
		let data3=data2.replaceAll(',','^');
		data['AaoeID']=data3;
		const aaoedata=Object.assign({aaoeanswers: data, required: 0}, props.test);
		dispatch(cartActions.add(aaoedata));
        notifyCart();
		setShowAAOEModal(false);
	};

    return (
    	  
        <div id={props.test.ID} className={TestClasses.dtctest} onClick={viewTestHandlerFull}>
        
            <span className={TestClasses.name}>{props.test.TestName}</span>
            <p className={TestClasses.description} dangerouslySetInnerHTML={{__html:props.test.DTCTestDescription}} />
				<span className={TestClasses.price}>${props.test.DTCPrice.toFixed(2)}</span>    		
				{menuTheme !== "HAMBURGER" ? (
				  <div className={TestClasses.bottomAreaTwoItems}>
					<Link className={TestClasses.buttonSecondary} to={testurl}>
						View Test
					</Link>
					{!testInCart ? (
					  <button className={TestClasses.buttonDarkBlue} onClick={addToCartHandler}>
						Add to Cart
					  </button>
					) : (
					  <button disabled className={TestClasses.buttonLightBlue}>
						Added to Cart
					  </button>
					)}
				  </div>
				) : (
				  <div className={TestClasses.bottomArea}>
					{!testInCart ? (
					  <button className={TestClasses.buttonDarkBlue} onClick={addToCartHandler}>
						Add to Cart
					  </button>
					) : (
					  <button disabled className={TestClasses.buttonLightBlue}>
						Added to Cart
					  </button>
					)}
				  </div>
				)}

			<AAOEModal 
			  isOpen={showAAOEModal}
			  onRequestClose={closeAAOEModal}
			  shouldCloseOnOverlayClick={true} // OK
			  shouldCloseOnEsc={true} // OK
			  contentLabel="Questions to be answered"
				style={{
				  content: {
					top: '200px',
					left: '50%',
					right: 'auto',
					bottom: 'auto',
					transform: 'translateX(-50%)',
					width: '60%',
					height: 'auto',
					padding: 0,
					background: 'transparent',
					border: 'none',
					boxShadow: 'none',
				  },
				  overlay: {
					backgroundColor: 'rgba(0, 0, 0, 0.5)',
				  }
				}}
			>
			  <div onClick={(e) => e.stopPropagation()}>
				<AAOE aaoes={aaoeData} onSubmit={handleAAOEData} onButtonClick={closeAAOEModal} />
			  </div>
			</AAOEModal>
        </div>
    );
};

export default Test;